<template>
    <BottomSheet ref="bts" v-model="bottomSheet" @onClose="onClose()">
        <div class="px-6 mt-6 text-center mb-8">
            <div class="text-right">
                <button type="button" class="outline-none" @click="hide">
                    <img src="@/assets/icon/dialog/close.svg" alt class="w-18px h-18px border-2 border-transparent" />
                </button>
            </div>
            <div class="text-lg text-primary uppercase" v-if="!isTitleEmpty">{{ title }}</div>
            <div class="mt-2 text-gray-secondary" :class="{'mr-6': isTitleEmpty}" v-if="!isMsgEmpty" v-html="message"></div>
            <div class="mt-4">
                <VBtn blocked large variant="primary" @click="clickOk()">{{ btnOk }}</VBtn>
            </div>
        </div>

        <!-- <template #dismiss="{ on }">
                <button type="button" class="outline-none" v-on="on">
                    <img src="@/assets/icon/dialog/close.svg" alt class="w-18px h-18px border-2 border-transparent" />
                </button>
        </template> -->
        <Footer :hasPoweredBy="false" />
    </BottomSheet>
</template>
<script>
import VBtn from "@/components/Button/VBtn.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import BottomSheet from "@/components/Dialog/BottomSheet.vue"

import LocaleMixin from "@/mixin/LocaleMixin";
import Utility from "@/helper/Utility";

export default {
    name: 'AlertBottomModal',
    components: {
        VBtn,
        Footer,
        BottomSheet
    },
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    emits: [],
    data: function () {
        return {
            bottomSheet: false,
            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        }
    },
    computed: {
        isMsgEmpty: function () {
            return Utility.isEmptyStr(this.message)
        },
        isTitleEmpty: function () {
            return Utility.isEmptyStr(this.title)
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    beforeUnmount: function () {
        this.busModal.off('show');
        this.busModal.off('hide');
    },
    methods: {
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Utility.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            this.$refs.bts.show()
        },
        hide: function () {
            this.$refs.bts.hide()
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        onClose: function () {
            this.controller.sendCallbackClose();
        }
    }
}
</script>
